import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";

export const signIncentiveSlice = createSlice({
	name: "sign-up-incentive",
	initialState,
	reducers: {
		setRewardsPopupFlag: (state, action: PayloadAction<boolean>) => {
			state.isRewardsPopupClosed = action.payload;
		}
	}
});

export const { setRewardsPopupFlag } = signIncentiveSlice.actions;

export default signIncentiveSlice.reducer;
